import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStyle } from 'react-native-style-utilities';

import { HStack, Modal, theme, useResponsive } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const AddToBagUnavailableIngredientsFooter = (props: PropsWithChildren) => {
  const { children } = props;

  const { match, currentBreakpoint } = useResponsive();
  const { bottom: safeAreaBottomInset } = useSafeAreaInsets();

  // ─── Derived ─────────────────────────────────────────────────────────

  const itemsPerRow = match([1, undefined]);

  // ─── Styles ──────────────────────────────────────────────────────────

  const footerDynamicStyles = useStyle(() => {
    if (!currentBreakpoint.isXS) return;

    return { paddingBottom: Math.max(safeAreaBottomInset, theme.spacing['6']) };
  }, [currentBreakpoint.isXS, safeAreaBottomInset]);

  const footerStyles = [styles.footer, footerDynamicStyles];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Modal.Footer style={footerStyles} withoutTopBorder>
      <HStack itemsPerRow={itemsPerRow} gap={theme.spacing['3']}>
        {children}
      </HStack>
    </Modal.Footer>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  footer: {
    marginTop: theme.spacing['8'],
  },
});
